import { AutoCompleteMulti, ISelectType, useFetch } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { insuranceRegisterList } from "../../../../../../services/ticketAutomationReceivedRuleInsurance.service";

const translationPath = "4uESign.page.automations.automationRules.";

export const InsurancesAutoComplete = memo(() => {
  const { t } = useTranslation();
  const { sendRequest } = useFetch(insuranceRegisterList);
  const [insurances, setInsurances] = useState<ISelectType[]>([]);

  const fetchOptions = useCallback(async () => {
    const { data, success } = await sendRequest(null);
    if (!success || !data) return;

    setInsurances(
      data.map((item) => ({
        id: item.identifier.toString(),
        name: item.insuranceName,
        code: item.identifier.toString(),
      })),
    );
  }, [sendRequest]);

  useEffect(() => {
    fetchOptions();
  }, [fetchOptions]);

  return (
    <Grid item xs={12}>
      <AutoCompleteMulti
        name="insurances"
        label={t(translationPath + "insurances")}
        options={insurances}
        getOptionLabel={(option) => option.name}
        size="small"
        fullWidth
        keepOpenOnSelect
      />
    </Grid>
  );
});
